import { ReactNode } from 'react';
import { TimelineContent } from 'app/agriculture/AgTimeline/TimelineContent';

export function TimelineRow({ heading, children }: { heading: string; children: ReactNode }) {
    return (
        <TimelineContent.Row data-testid="TimelineRow" heading={heading}>
            <TimelineContent.Main>{children}</TimelineContent.Main>
        </TimelineContent.Row>
    );
}
